import { infoService } from "common/services/info";
import SpinnerMedium from "components/Spinner/Medium";
import Tabs from "components/Tabs";
import Tab from "components/Tabs/Tab";
import PageTitle from "components/Title/Page";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ClinicInfo from "./ClinicInfo";
import ClinicDoctorList from "./ClinicDoctorList";
import axios from "axios";
import ClinicEventList from "./ClinicEventList";
import ClinicReviewList from "./ClinicReviewList";
import TopNav from "common/components/TobNav";
import { staffClient } from "common/apis/staff";
import { UrlUtils } from "components/Utils/url";
import { CalendarDaysIcon, HeartIcon } from "@heroicons/react/24/outline";
import Button from "components/Form/Button";
import BottomBookmarkBar from "common/components/BottomBookmarkBar";
import { formatKoreanAddress } from "components/Form/KoreanAddressInput";
import numeral from "numeral";
import { StarIcon } from "@heroicons/react/24/solid";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './styles.scss'

const BannerImage = ({ image }) => {
    return (
        //cover
        <div className="h-[180px]">
            <img src={UrlUtils.convertCdnUrl(image?.url)} alt="banner" className="w-full h-full object-cover" />
        </div>
    )
}

const ClinicDetail = () => {
    const { clinicId } = useParams();
    const [clinicInfo, setClinicInfo] = useState(null);

    useEffect(() => {
        if (clinicId === "pv") {
            console.log("[ClinicDetail] clinic id is empty it's maybe preview page");
            console.log("[ClinicDetail] try get from localstorage");
            const tempClinicInfoStr = localStorage.getItem("tempClinicInfo");
            if (_.isNil(tempClinicInfoStr)) {
                console.log("[ClinicDetail] tempClinicInfo is empty");
                return;
            }
            const tempClinicInfo = JSON.parse(tempClinicInfoStr);
            console.log("[ClinicDetail] tempClinicInfo", tempClinicInfo);
            setClinicInfo(tempClinicInfo);
            return;
        }
        fetchClinicInfo();
    }, [clinicId]);

    const fetchClinicInfo = async () => {
        if (_.isNil(clinicId)) {
            return;
        }
        try {
            const ret = await axios.get(`https://rest.miview.shop/public/clinics/${clinicId}`);
            // const ret = await staffClient.get(`/clinic/${clinicId}`);
            console.log("[fetchClinicInfo] ret", ret.data);
            setClinicInfo(ret.data);
        } catch (e) {
            console.error("[fetchClinicInfo] error", e);
        }
    }

    if (_.isNil(clinicInfo)) {
        return <SpinnerMedium />;
    }

    return (
        <div className="pb-16">
            <TopNav
                pages={[
                    {
                        name: "탐색",
                        path: "/contents"
                    },
                    {
                        name: "의원",
                        path: "/contents?tabId=clinics"
                    },
                    {
                        name: clinicInfo.name
                    }
                ]}
                disablePlus={true}
            />
            <div hidden={_.isEmpty(clinicInfo.bannerImage)}>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={30}
                    loop={true}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="mySwiper"
                >
                    {!_.isEmpty(clinicInfo.bannerImage) &&
                        <SwiperSlide>
                            <BannerImage image={clinicInfo.bannerImage} />
                        </SwiperSlide>
                    }
                    {!_.isEmpty(clinicInfo.introductionImages) &&
                        clinicInfo.introductionImages.map((image, index) => (
                            <SwiperSlide key={index}>
                                <BannerImage image={image} />
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
                {/* <img src={UrlUtils.convertCdnUrl(clinicInfo.bannerImage?.url)} alt="banner" /> */}
            </div>
            <div className="p-3">
                <div className="flex flex-col">
                    <div className="text-lg font-bold self-center">
                        {clinicInfo.name}
                    </div>
                    <div className="self-center flex mb-1">
                        <StarIcon className="w-4 h-4 text-yellow-400" />
                        <span className="text-gray-500 text-xs">
                            {numeral(clinicInfo.averageRating).format("0.0")}
                        </span>
                        <span className="ms-[2px] text-gray-600 text-xs">
                            {`(${numeral(clinicInfo.reviewCount).format("0,0")}개의 후기)`}
                        </span>
                    </div>
                    <div className="text-sm text-gray-500 self-center">
                        {formatKoreanAddress(clinicInfo.address)}
                    </div>
                </div>
            </div>
            <div className="border-t border-gray-200"></div>
            <Tabs tabsClassnames='sticky top-0 bg-white' isEvenFullWidth={true}>
                <Tab title='병원정보' path="info">
                    <ClinicInfo clinicInfo={clinicInfo} />
                </Tab>
                <Tab title='의료진' path="doctor">
                    <ClinicDoctorList clinicInfo={clinicInfo} />
                </Tab>
                <Tab title='이벤트' path="event">
                    <ClinicEventList clinicInfo={clinicInfo} />
                </Tab>
                <Tab title='시술후기' path="review">
                    <ClinicReviewList clinicInfo={clinicInfo} />
                </Tab>
            </Tabs>
            <BottomBookmarkBar
                clinicId={Number(clinicId)}
                bookmarkableId={Number(clinicId)}
                bookmarkableType="CLINIC"
            />
        </div>
    )
}

export default ClinicDetail;
